import { Dropzone } from '@openx/components-core/lib/Dropzone/Dropzone';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { Details, Fields } from '../../../types';

interface CSVDropzoneProps {
  fieldName: typeof Fields.BUNDLES | typeof Fields.DOMAINS;
}

export const CSVDropzone = ({ fieldName }: CSVDropzoneProps) => {
  const {
    formState: { isSubmitting },
  } = useFormContext<Details>();
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController<Details>({
    name: fieldName,
  });
  const { t } = useTranslation();

  return (
    <Dropzone
      helpMessage={t('CSV file format required')}
      disabled={isSubmitting}
      file={value as File | null}
      errorMessage={error?.message}
      onDropFile={file => {
        onChange(file);
      }}
      onCancel={() => {
        onChange(null);
      }}
    />
  );
};
